import React from "react";

export interface LogoProps {
  /** Kantenlänge des Logo-Symbols in Pixeln. */
  size?: number;
  /** Wortmarke "Orcmatic" neben dem Symbol anzeigen. */
  showWordmark?: boolean;
  /** Farbton der Wortmarke — `light` für dunkle, `dark` für helle Hintergründe. */
  tone?: "light" | "dark";
}

/** Reines Orca-Bildzeichen (Walflosse über einer Welle). */
export function LogoMark({ size = 32 }: { size?: number }) {
  const gid = React.useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Orcmatic"
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#22d3ee" />
          <stop offset="0.55" stopColor="#0891b2" />
          <stop offset="1" stopColor="#0a2540" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill={`url(#${gid})`} />
      {/* Walflosse / Fluke */}
      <path
        d="M32 30C30 26 26 23 20 22C24 30 28 36 31 43L33 43C36 36 40 30 44 22C38 23 34 26 32 30Z"
        fill="#ffffff"
      />
      {/* Welle */}
      <path
        d="M10 50C18 45 24 53 32 49C40 45 46 53 54 49"
        stroke="#ffffff"
        strokeWidth="3.5"
        strokeLinecap="round"
        opacity="0.9"
      />
    </svg>
  );
}

/** Orca-Bildzeichen mit optionaler Wortmarke. */
export function Logo({ size = 32, showWordmark = true, tone = "dark" }: LogoProps) {
  const wordColor = tone === "light" ? "#ffffff" : "var(--color-brand-900)";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "0.6rem" }}>
      <LogoMark size={size} />
      {showWordmark && (
        <span
          style={{
            fontSize: `${Math.round(size * 0.62)}px`,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            color: wordColor,
            lineHeight: 1,
          }}
        >
          Orcmatic
        </span>
      )}
    </span>
  );
}
